module.exports = __webpack_public_path__ + "static/media/f4db1aa1.jpg";